<template>
    <div v-if="isToggledRepsHistory">
        <div class="reps_card" v-if="repetitions.length == 0">
            <div class="row">
            <div class="col-12">No reps recorded for this task!</div>
            </div>
        </div>
        <div class="reps_card" v-for="(item, index) in repetitions" :key="index" v-else>
            <div class="row">
            <div class="col-6 font-weight-bold">
                # {{ (repetitions.length - index) }}<span v-if="subtaskId != 99999"> - Rating: {{ item.score }} </span>
                <a href="javascript:void(0);" @click="onEditRep(item, index)" class="edit-rep" v-if="!isMentee && parent_form=='add_reps'">
                    Edit
                </a>
            </div>
            <div class="col-6 text-right">{{ item.createdAt | formatDate }} </div>
            </div>
            <div class="row">
            <div class="col-6">Mentor: {{ item.mentor_name }}</div>
            </div>
            <div class="row mt-2">
            <div class="col-6 font-weight-bold" v-if="item.score">Comment:</div>
            <div class="col-6 font-weight-bold" v-else>&nbsp;</div>
            <div class="col-6 text-right font-weight-bold">Time on Task: </div>
            </div>
            <div class="row">
            <div class="col-6" v-if="subtaskId != 99999">{{ item.comment }}</div>
            <div class="col-6" v-else>&nbsp;</div>
            <div class="col-6 text-right">{{ item.timeOnTask | formatHourMin }}</div>
            </div>
            <div class="row mt-2" v-if="!isMentee && parent_form=='add_reps'">
                <div class="col-12 font-weight-bold">
                    <a href="javascript:void(0);" class="delete-rep" @click="onDeleteRep(item, index)">
                        Delete
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    props: [
        'menteeId',
        'tasklistId',
        'taskId',
        'subtaskId',
        'parent_form',
        'isSection',
        ],
    data() {
        return{
            repetitions: [],
            isToggledRepsHistory: false,
            isMentee: false,
        }
    },
    methods: {
        fetchRepsHistory() {
            if (!this.isToggledRepsHistory) {
                this.isToggledRepsHistory = true;
                this.$parent.toggleFontIcon = 'fa fa-angle-up';
                axios.get('/mobile/mentee-repetitions-task', {
                params: {
                    mentee_id: this.menteeId,
                    task_id: this.taskId,
                    tasklist_id: this.tasklistId,
                    account_id: this.$store.state.user_accountid,
                    is_section: this.isSection,
                }
                })
                .then(response =>  {
                    this.repetitions = response.data.repetition;
                })
                .catch(() => {
                    console.log("error comes")
                });
            } else {
                this.hideRepsHistory();
            }
            var roles = this.$store.state.roles;
            if(roles.indexOf('ROLE_MENTEE') > -1) {
                this.isMentee = true;
            }
        },
        hideRepsHistory() {
            this.isToggledRepsHistory = false;
            this.$parent.toggleFontIcon = 'fa fa-angle-down';
            this.repetitions = [];
        },
        onEditRep(item, index) {
            var rep_number = (this.repetitions.length - index);
            this.hideRepsHistory();
            this.$parent.displayReps = false;
            this.$parent.editReps = true;
            var hours = (item.timeOnTask / 60);
            var rhours = Math.floor(hours);
            var minutes = (hours - rhours) * 60;
            var rminutes = Math.round(minutes);
            item['rep_number'] = rep_number;
            item['hours'] = rhours;
            item['minutes'] = rminutes;
            //console.log(item)
            this.$parent.showEditRep(item);
            this.$parent.modalTitle = 'Edit Rep #' + rep_number;
        },
        onDeleteRep(item, index) {
            var rep_number = (this.repetitions.length - index);
            this.hideRepsHistory();
            item['rep_number'] = rep_number;
            this.$parent.displayReps = false;
            this.$parent.deleteReps = true;
            this.$parent.deleteRepItem = item;
            this.$parent.modalTitle = 'Delete Rep #' + rep_number;
        },
    }
}
</script>
<style scoped>
.reps_card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.edit-rep {
    font-size: 13px;
    text-decoration: none;
    margin-left: 15px;
}
.delete-rep {
    color: #FF0000;
    font-size: 13px;
    text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/repetition_history.vue